module.exports = __webpack_public_path__ + "static/img/main6_7.a8aa647a.png";